import { type ReactNode } from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import type { ButtonType } from 'shared/components/button/types/button-interface'

const DangerButton = (props: ButtonType): ReactNode => (
  <BaseButton
    color={'text-background-secondary'}
    hoverColor={'hover:text-background-secondary'}
    backgroundColor={'bg-danger'}
    hoverBackgroundColor={'hover:bg-danger'}
    {...props}
  />
)
export default DangerButton
